export function defineHub(options) {
    return options;
}
// #endregion
// #region Core
export class HubOperation {
    // #region Properties
    instance;
    command;
    factory;
    args;
    // #endregion
    // #region Properties
    get appHost() {
        return this.factory.appHost;
    }
    // #endregion
    // #region Constructor
    constructor(factory, instance) {
        this.factory = factory;
        this.instance = this.factory.getInstance(instance);
        this.command = { method: "Get", operation: '', address: '' };
    }
    // #endregion
    // #region Fluent
    withInstance(instance) {
        this.instance = {
            ...this.instance,
            ...this.factory.getInstance(instance)
        };
        return this;
    }
    withSubInstance(instance) {
        this.instance = {
            ...this.instance,
            ...this.factory.getSubInstance(instance)
        };
        return this;
    }
    withCommand(command) {
        this.command = command ?? {};
        return this;
    }
    withAddress(address) {
        this.command.address = address;
        return this;
    }
    withOperation(operation) {
        this.command.operation = operation;
        return this;
    }
    withMethod(method) {
        this.command.method = method;
        return this;
    }
    withArgs(args) {
        this.args = args;
        return this;
    }
    withParams(params) {
        this.command.params = params;
        return this;
    }
    withData(data) {
        this.command.data = data;
        return this;
    }
    cloneNew() {
        return new HubOperation(this.factory, this.instance);
    }
    // #endregion
    // #region Core
    async send() {
        return await this.factory.send('operationRun', this.instance, this.command);
    }
    async invoke() {
        return await this.factory.invoke('operationInvoke', this.instance, this.command);
    }
}
// #endregion
